import config from "../../config/config.json";
import { headers } from "../../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuthWithoutBody,
  cancelPreviousRequest,
  decryptResponse,
  headersWithAuth
} from "../../APIHelpers/Responses";

export const loginActivitiesServices = {
  getBruteForceAttackRecord,
  updateStatusBruteForceAttackedDevice,

  getLoginHistoryRecord,
};


// Get Brute Force Attack Record 
async function getBruteForceAttackRecord(type, page, length) {
  try {
    const signal = cancelPreviousRequest("getBruteForceAttackRecord");
    let apiURL = `${config.API_URL_USER_ONBOARDING}getBruteForceAttackRecord/${type}?page=${page}&length=${length}`
    const response = await fetch(apiURL, {
      ...headersWithAuthWithoutBody("GET", headers),
      signal
    });
    const result = await response.json();
    const data = decryptResponse(result);
    if (data?.statusCode === 401) {
      handleResponse(data)
    }
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}

// Update Status Brute Force Attacked Device
async function updateStatusBruteForceAttackedDevice(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateStatusBruteForceAttackedDevice`,
    headersWithAuth("PUT", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Get Login History Record
async function getLoginHistoryRecord(type, page, length) {
  try {
    const signal = cancelPreviousRequest("getLoginHistoryRecord");
    let apiURL = `${config.API_URL_USER_ONBOARDING}getLoginHistoryRecord/${type}?page=${page}&length=${length}`
    const response = await fetch(apiURL, {
      ...headersWithAuthWithoutBody("GET", headers),
      signal
    });
    const result = await response.json();
    const data = decryptResponse(result);
    if (data?.statusCode === 401) {
      handleResponse(data)
    }
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}